export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12057.f713d68d.jpg";